/**
 * File slick-custom.js.
 *
 *
 *
 * Contains scripts to for all the slick sliders Customisation
 */

(function ($) {

	$(document).ready(function () {
		$('.front-page-slider').slick({
			dots: true,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			centerPadding: '100px',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						initialSlide: 1,
					}
				}
			]
		});

		$('.festive-slider').slick({
			dots: true,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			centerPadding: '100px',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						initialSlide: 1,
					}
				}
			]
		});

		// timeline-slider
		$('.wp-block-rhm-block-rhm-block-timeline').slick({
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			// centerMode: true,
			// centerPadding: '-50%',
			dots: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
					}
				}
			]
		});

		// timeline-slider
		$('.testimonial-slider').slick({
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
		});

		// press slider
		$('.wp-block-rhm-block-rhm-block-press').slick({
			dots: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			slidesPerRow: 1,
			arrows: true,
			centerMode: true,
			adaptiveHeight: true,
			initialSlide: 1,
			centerPadding: '0',
			variableWidth: true,
			infinite: true,
			variableHeight: true,
		});

		// events gallery slider
		$('.event-gallery').slick({
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			centerMode: true,
			centerPadding: '0',
			infinite: false,
		});


		// venue widget slider
		$('.venue-slider-wrapper').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			arrows: true,
			centerMode: true,
			centerPadding: '200px',
			infinite: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '100px',
						infinite: true,

					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '250px'
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '50px'
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: true,
						centerPadding: '90px'
					}
				}
			]

		});

	});


})(jQuery);